import React, { Component } from "react";
import {
  ContentContainer,
  Title,
  Date
} from "./FilteredViewCardFooter.style";
import dayjs from 'dayjs';
/**
 * ---------------------------------------------------------
 * 
 * 
 * 
 *               더 이상 안쓰는 컴포넌트, 삭제 예정  
 * 
 * 
 * 
 * ---------------------------------------------------------
 */
export class FilteredViewCardFooter extends Component {
  render() {
    const {
      title,
      date
    } = this.props
    return (
      <ContentContainer>
        <Title>{title}</Title>
        <Date>{`${dayjs(date).year()}.${dayjs(date).month() + 1}.${dayjs(date).date()}`}</Date>
    </ContentContainer>
    );
  }
}
